module.exports = __webpack_public_path__ + "static/img/39.09844ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/39.png
// module id = vvuF
// module chunks = 0